<template>
  <div class="group-link-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-collection-tag"></i> Monthly fee group link</span>
        <el-button icon="el-icon-plus" style="float: right; padding: 0" type="text"
          @click="showDialog()">Create Group</el-button>
      </div>
      
      <el-table
        v-loading="loading"
        ref="tableemberMonthlyfeeGroup"
        :data="groupList"
        style="width: 100%"
        row-key="id"
        border
        lazy
        :load="loadMembers"
        :row-class-name="tableRowClassName"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >

      <el-table-column label="Group / Member Name">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'group'" style="font-weight: bold;">
            <i class="el-icon-folder-opened"></i> {{ scope.row.name }}
          </span>
          <span v-else>
             ({{ scope.row.memberCode }})
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Code" width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 'group' && scope.row.closedCount > 0" type="danger" size="mini" effect="dark">{{ scope.row.closedCount }} closed</el-tag>
          <span v-else>{{ scope.row.memberCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project Name"></el-table-column>
      <el-table-column label="Customer Name">
        <template slot-scope="scope">
          <span>{{ scope.row.customerName }}</span>
          <span v-if="isMemberClosed(scope.row)" style="color: #f56c6c; font-weight: bold;"> - AC Closed</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="enduserId" label="EndUser ID" show-overflow-tooltip></el-table-column> -->
      <el-table-column label="Debt" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'group'" :style="{ fontWeight: 'bold', color: scope.row.hasDebt ? '#f56c6c' : null }">
             {{ scope.row.hasDebt ? 'Has Debt' : 'No Debt' }}
          </span>
          <span v-else>
             {{ scope.row.totalDebt }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Action" width="260">
        <template slot-scope="scope">
           <el-button icon="el-icon-plus" v-if="scope.row.type === 'group'" type="success" size="mini" @click="addToGroup(scope.row)">Add Member</el-button>
           <el-button icon="el-icon-money" v-if="scope.row.type === 'group' && scope.row.hasDebt" type="danger" size="mini" :loading="collectingGroup === scope.row.name" :disabled="!!collectingGroup && collectingGroup !== scope.row.name" @click="handleCollectDebt(scope.row)">Collect Debt</el-button>
          <el-button icon="el-icon-delete" v-if="scope.row.type === 'member'" type="danger" size="mini" @click="handleDelete(scope.row)">Del</el-button>
        </template>
      </el-table-column>
      
    </el-table>
    </el-card>

    <create-group-dialog ref="createGroupDialog" @saved="fetchData"/>

  </div>
</template>

<script>
import { getMonthlyfeeGroup, deleteMemberMonthlyfeeGroup } from '@/api/linkgroup'
import { submitGroupCollection } from '@/api/debt'
import CreateGroupDialog from './group-create.vue'

export default {
  components:{
    CreateGroupDialog
  },
  data() {
    return {
      loading: false,
      allData: [],
      groupList: [],
      collectingGroup: null,
      // groupName -> idempotencyKey ที่ยังไม่ได้ผลลัพธ์ (reuse ตอน retry ตาม spec ของ API)
      pendingCollectKeys: {},
    }
  },
  methods: {
    // A member is considered closed when it has no active account left but at least one closed account
    isMemberClosed(row){
      return row.type === 'member' && Number(row.activeCount) === 0 && Number(row.closedCount) > 0;
    },
    tableRowClassName({ row }){
      if(this.isMemberClosed(row)) return 'closed-row';
      if(row.type === 'group' && row.hasDebt) return 'has-debt-row';
      return '';
    },
    fetchData(){
      this.loading = true;
      getMonthlyfeeGroup().then(({result, data})=>{
        this.loading = false;
        if(result){
          this.allData = data;
          this.initGroups();
          
          // *** เพิ่มบรรทัดนี้: อัปเดตข้อมูลลูกในตารางที่กางอยู่ ***
          this.refreshLazyTree(); 
        }
        
      }) .catch(() => {
          this.loading = false
      })
    },

    // *** ฟังก์ชันใหม่: เอาข้อมูลใหม่ไปแปะทับใน Cache ของตาราง ***
    refreshLazyTree() {
      const table = this.$refs.tableemberMonthlyfeeGroup;
      if (!table) return;

      // lazyTreeNodeMap คือตัวเก็บข้อมูลลูกที่โหลดมาแล้ว (Key คือ ID ของ Group)
      const { lazyTreeNodeMap } = table.store.states;
      
      // วนลูปทุก Group ที่กำลังกางอยู่ (Expanded)
      Object.keys(lazyTreeNodeMap).forEach(groupId => {
        // กรองหาลูกๆ ของ Group นี้จาก allData ตัวใหม่ล่าสุด
        const updatedChildren = this.allData
          .filter(item => item.monthlyChargeGroup === groupId)
          .map(item => ({
             ...item,
             id: item.uid,      
             type: 'member',   
             hasChildren: false 
          }));
        
        // ใช้ $set เพื่อให้ Vue รู้ว่าค่าเปลี่ยนแล้ว (Reactivity)
        this.$set(lazyTreeNodeMap, groupId, updatedChildren);
      });
    },

    showDialog(){
      this.$refs['createGroupDialog'].show()
    },
    addToGroup(item){
      this.$refs['createGroupDialog'].show(item.name)
    },
    initGroups(){
      const uniqueGroups = [...new Set(this.allData.map(item => item.monthlyChargeGroup))];
      this.groupList = uniqueGroups.map(groupName => {
        const membersInGroup = this.allData
          .filter(item => item.monthlyChargeGroup === groupName);

        const hasDebt = membersInGroup
          .some(item => item.totalDebt && item.totalDebt.trim() !== '' && item.totalDebt !== '-');

        // Count members whose accounts are all closed within this group
        const closedCount = membersInGroup
          .filter(item => Number(item.activeCount) === 0 && Number(item.closedCount) > 0)
          .length;

        return {
          id: groupName,
          name: groupName,
          type: 'group',
          hasChildren: true,
          memberCode: '-',
          enduserId: '-',
          hasDebt,
          closedCount
        }
      });
    },
    loadMembers(row, treeNode, resolve) {
      setTimeout(() => {
        const members = this.allData
          .filter(item => item.monthlyChargeGroup === row.id)
          .map(item => ({
             ...item,
             id: item.uid,      
             type: 'member',   
             hasChildren: false 
          }));

        resolve(members);
      }, 500);
    },
    handleCollectDebt(row){
      this.$confirm(`Collect failed monthly charges for every active member of group "${row.name}", Continue?`, 'Collect Debt', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const groupName = row.name;
        if(!this.pendingCollectKeys[groupName]){
          this.pendingCollectKeys[groupName] = `gc_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
        }
        this.collectingGroup = groupName;
        submitGroupCollection(groupName, this.pendingCollectKeys[groupName]).then(({result, message, data}) => {
          this.collectingGroup = null;
          delete this.pendingCollectKeys[groupName];
          const d = data || {};
          const summary = `
            <div>${message || ''}</div>
            <ul style="margin: 8px 0 0; padding-left: 20px;">
              <li>Members: ${d.memberCount || 0}</li>
              <li>Collected: ${d.collectedCount || 0}</li>
              <li>No debt: ${d.noDebtCount || 0}</li>
              <li>Failed: ${d.failedCount || 0}</li>
              <li>Processing: ${d.processingCount || 0}</li>
              <li>Unprocessed: ${d.unprocessedCount || 0}</li>
            </ul>`;
          this.$alert(summary, `Collect Debt - ${groupName}`, {
            dangerouslyUseHTMLString: true,
            type: result && !d.failedCount && !d.unprocessedCount ? 'success' : 'warning',
            confirmButtonText: 'OK'
          });
          this.fetchData();
        }).catch(() => {
          // เก็บ idempotencyKey ไว้ ให้กดซ้ำแล้วใช้ key เดิม (retry submit เดิม)
          this.collectingGroup = null;
        })
      }).catch(() => {});
    },
    handleDelete(row){
       this.$confirm('Are you sure you want to delete this Member, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          deleteMemberMonthlyfeeGroup(row.enduserId).then(({result}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete Member successfully`,
                type: 'success',
                duration: 2000
              });
              
              // วิธีที่ 1: ลบเอง Manual (เร็ว ไม่โหลดใหม่)
              this.allData = this.allData.filter(item => item.uid !== row.uid);
              const parentId = row.monthlyChargeGroup;
              const { lazyTreeNodeMap } = this.$refs.tableemberMonthlyfeeGroup.store.states;
              if (lazyTreeNodeMap[parentId]) {
                lazyTreeNodeMap[parentId] = lazyTreeNodeMap[parentId].filter(child => child.id !== row.uid);
              }
              
              // วิธีที่ 2 (Option): ถ้าอยากชัวร์ก็เรียก fetchData() ก็ได้ เพราะเราแก้ Logic แล้ว
              // this.fetchData(); 
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    }
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
.group-link-container >>> .closed-row td.el-table__cell {
  background-color: #fef0f0;
  color: #f56c6c;
}
.group-link-container >>> .has-debt-row td.el-table__cell {
  background-color: #fef0f0;
  color: #f56c6c;
}
</style>